import { Instance } from 'mobx-state-tree';
import { VisitUnschedulingDtoModelBase } from './VisitUnschedulingDtoModel.base';

/* The TypeScript type of an instance of VisitUnschedulingDtoModel */
export interface VisitUnschedulingDtoModelType extends Instance<typeof VisitUnschedulingDtoModel.Type> {}

/* A graphql query fragment builders for VisitUnschedulingDtoModel */
export { selectFromVisitUnschedulingDto, visitUnschedulingDtoModelPrimitives, VisitUnschedulingDtoModelSelector } from './VisitUnschedulingDtoModel.base';

/**
 * VisitUnschedulingDtoModel
 */
export const VisitUnschedulingDtoModel = VisitUnschedulingDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
